import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=79218852&"
import script from "./Marketing.vue?vue&type=script&lang=js&"
export * from "./Marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports